import React from 'react';
import {Button, Modal} from "react-bootstrap";

const InputSampleDeletionModal = (props) => {
    return <Modal show={props.show} onHide={props.onHide} size="lg"
                  aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
                Yakin ingin hapus?
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <p>Data barang ini akan hilang dari daftar sampel.</p>
        </Modal.Body>
        <Modal.Footer>
            <Button variant={'outline-success'} onClick={props.onHide}>Batal</Button>
            <Button variant={'success'} onClick={() => props.onDelete(props.index)}>Hapus</Button>
        </Modal.Footer>
    </Modal>
}

export default InputSampleDeletionModal;